import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../../../../core';
import * as Forms from '../../../../../components/forms';
import Translate from '../../../../../core/translate';
import { IResponse } from '../../../../../services/model';
import Common, { FormService } from '../../../../../services/common';
import { IFileContent } from '../../../../../services/api/services/model';

export interface IComprobantePago {
  id?: number;
  comentario?: string;
  adjunto?: IFileContent;
}

interface IProps {
  storage?: IDataStorage;
  refService?: (form:FormService<IComprobantePago>) => void;

  id?: number;
  readonly?: boolean;
}

interface IState {
  storage?: IDataStorage;
  id?: number;
  readonly?: boolean;

  entity?: IComprobantePago;
}

class Index extends React.Component<IProps, IState> {
  form : FormService<IComprobantePago>;
  constructor(props:IProps) {
    super(props);
    this.form = Common.form(() => this.getEntity);
  }

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.loadEntities(this.state.id);
    this.props.refService && this.props.refService(this.form);
  }

  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.id !== s?.id) res.id = p.id;
    if (p?.readonly !== s?.readonly) res.readonly = p.readonly;
    return res;
  }

  private loadEntities = (id?: number) => {
    this.setState({ entity: this.form.setEntity({}) })
  }

  private change = (field: string, value: any, error?: string, callback?: () => void) => {
    this.setState({ entity:this.form.setValue(field, value, error) }, callback);
  }

  render() {
    const { readonly, entity } = this.state;
    const t = Translate.get("reporte/operacion/comprobantepago", this.state.storage?.languaje);

    return <>
      <Forms.Input form={this.form} name='comentario' title={t("Col.comentario")} placeholder={t("Col.comentario.Placeholder")} disabled={readonly} value={entity?.comentario} onChange={(v, e) => this.change('comentario', v, e)} />
      <Forms.UploadSingleFile form={this.form} name='adjunto' maxSize={1000} required title={t("Col.adjunto")} placeholder={t("Col.adjunto.Placeholder")} disabled={readonly} value={entity?.adjunto} onChange={(v, e) => this.change('adjunto', v, e)} />
    </>;
  }
  
  /** devuelve la entidad */
  getEntity = () : IResponse<IComprobantePago> => {
    var isValid = this.form.isFormValid();
    if (!isValid) {
      return { success: false, error: (this.form.getStatus().errors ?? [])[0] };
    } else {
      const data = this.form.form.getEntity();
      return { success: true, data };
    }
  }
}

export { Index }
export default connect((s:any) => ({ storage:s.main }))(Index);
